import { Component } from '@angular/core';
import { RegistrationStepService, StepType } from '@fgb/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-registration-marketing-page',
  templateUrl: './registration-marketing-page.component.html',
  styleUrl: './registration-marketing-page.component.scss',
})
export class RegistrationMarketingPageComponent {
  constructor(private registrationStepService: RegistrationStepService) {}

  submitStep() {
    firstValueFrom(this.registrationStepService.submitRegistrationStepData(StepType.Marketing, { Accepted: true }));
  }
}
